import React from "react";

const Loading = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative w-4 h-4 rounded-full bg-blue-500 animate-dots">
        <style>
          {`
            @keyframes dots {
              0% { box-shadow: 20px 0 #60a5fa, -20px 0 rgba(96, 165, 250, 0.2); background: #60a5fa; }
              33% { box-shadow: 20px 0 #60a5fa, -20px 0 rgba(96, 165, 250, 0.2); background: rgba(96, 165, 250, 0.2); }
              66% { box-shadow: 20px 0 rgba(96, 165, 250, 0.2), -20px 0 #60a5fa; background: rgba(96, 165, 250, 0.2); }
              100% { box-shadow: 20px 0 rgba(96, 165, 250, 0.2), -20px 0 #60a5fa; background: #60a5fa; }
            }
            .animate-dots {
              animation: dots 1s infinite linear alternate;
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default Loading;
